import { render, staticRenderFns } from "./GradientDonut.vue?vue&type=template&id=df8875e0&scoped=true&"
import script from "./GradientDonut.vue?vue&type=script&lang=js&"
export * from "./GradientDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8875e0",
  null
  
)

export default component.exports